import React, { useEffect, useRef, useState } from 'react';
import modalImage from '../../Image/modal.jpeg';
import './Modal.css';

const ModalComponent = () => {
  const [modalIsOpen, setModalIsOpen] = useState(true);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!modalIsOpen) {
      return undefined;
    }

    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        setModalIsOpen(false);
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleEscapeKey);
    closeButtonRef.current?.focus();

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [modalIsOpen]);

  if (!modalIsOpen) {
    return null;
  }

  const closeModal = () => setModalIsOpen(false);

  return (
    <div
      className="modal-overlay"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          closeModal();
        }
      }}
    >
      <div
        className="modal-poster"
        role="dialog"
        aria-modal="true"
        aria-label="WBCAP 2026-27 mop-up phase schedule of events"
      >
        <img
          className="modal-poster__image"
          src={modalImage}
          alt="WBCAP 2026-27 mop-up phase decentralised admission portal schedule of events"
        />
        <button
          ref={closeButtonRef}
          className="modal-poster__close"
          type="button"
          onClick={closeModal}
          aria-label="Close admission schedule"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  );
};

export default ModalComponent;
